import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'aoe-dialog-video',
  templateUrl: './dialog-video.component.html',
  styleUrls: ['./dialog-video.component.scss'],
  imports: [
    CommonModule,
    MatDialogModule
  ]
})
export class DialogVideoComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { videoId: string }
  ) { }

  ngOnInit(): void {
  }

  get videoLink(): string {
    return `${environment.apiUrl}/video/${this.data.videoId}`;
  }

}
